/** Mirrors backend `EstimateCategoryBehavior` */
export enum EstimateCategoryBehavior {
  MATERIALS_FROM_BOM = "materials_from_bom",
  LABOR_FROM_CREW = "labor_from_crew",
  COST_WITH_MARGIN = "cost_with_margin",
  UNIT_PRICED = "unit_priced",
  DIRECT_SALES_PRICE = "direct_sales_price",
  SALES_TAX_COMPUTED = "sales_tax_computed",
}

const BEHAVIOR_VALUES = new Set<string>(Object.values(EstimateCategoryBehavior));

/**
 * GraphQL often returns enum **member names** (e.g. `COST_WITH_MARGIN`) while this app
 * compares against enum **values** (`cost_with_margin`). Normalize wire values to values.
 */
export function normalizeEstimateCategoryBehavior(
  raw: string | null | undefined
): EstimateCategoryBehavior | undefined {
  if (raw == null || typeof raw !== "string") return undefined;
  const key = raw.trim().toLowerCase();
  if (BEHAVIOR_VALUES.has(key)) return key as EstimateCategoryBehavior;
  return undefined;
}
